import React from "react";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import MuiButton from "../../../components/basicComponent/MuiButton";
import { useGlobalState } from "../../../services/context/AuthContext";

export interface RoomOption {
  Meal: string;
  NP: number;
  NT: number;
  disc?: number;
  TotalPrice: number;
  CancellationPolicy: string;
  roomType: string;
  RateKey: string;
  RoomTypeCode: string;
  MealType: string;
  Engine: number;
  HotelID: string;
  currencyCode: string;
  roomTypeCode: string;
  roomTypeName: string;
  roomTypeDescription: string;
}

interface RoomListProps {
  rooms: RoomOption[];
  hotelImageUrl: string;
  onBookRoom?: (room: RoomOption) => void;
}

const RoomList: React.FC<RoomListProps> = ({
  rooms,
  hotelImageUrl,
  onBookRoom,
}) => {
  const { userInfo } = useGlobalState();
  const currency = userInfo?.currencyCode || "AED";
  return (
    <>
      <h2 className="tab-title">Available Rooms</h2>
      <div className="card-content">
        {/* Hotel Image Section */}
        <div className="room-image-section">
          <div className="image-container">
            {hotelImageUrl ? (
              <>
                <img
                  src={hotelImageUrl}
                  alt="Room Preview"
                  className="room-image"
                />
                <div className="thumbs-up-badge">
                  <ThumbUpAltIcon />
                </div>
              </>
            ) : (
              <div className="no-image-found">
                <p>No image found</p>
              </div>
            )}
          </div>
        </div>

        {/* Room Options */}
        <div className="room-options-section">
          {rooms.length === 0 ? (
            <div className="text-center text-muted">No rooms available.</div>
          ) : (
            rooms.map((room, index) => {
              const mealOptions =
                room.Meal?.split(",").map((m) => m.trim()) || [];

              const oldPrice = room.NP || 0;
              const discount = room.disc || 0;
              const currentPrice = oldPrice - discount;
              const taxes = room.NT || 0;

              return (
                <div key={index} className="room-option">
                  <div className=" row">
                    {/* Room Info */}
                    <div className="option-info col-md-6">
                      <h3>{room.roomTypeName || room.roomType || "Room"}</h3>

                      {mealOptions.map((meal, idx) => (
                        <p key={idx} className="option-description">
                          <DoneAllIcon /> {meal}
                        </p>
                      ))}

                      <p className="option-description">
                        <DoneAllIcon />{" "}
                        {room.CancellationPolicy ||
                          "Cancellation info not available"}
                      </p>
                    </div>

                    {/* Price Info */}
                    <div className="price-info  col-md-6">
                      <div className="old-price text-decoration-line-through text-danger">
                        {currency} {oldPrice.toLocaleString()}
                      </div>

                      <div className="current-price fw-bold">
                        <span className="fs-5">{currency} </span>{" "}
                        {currentPrice.toLocaleString()}
                      </div>

                      <div className="taxes text-muted small">
                        + {currency} {taxes.toLocaleString()} Taxes & fees
                      </div>

                      <div className="per-night small text-muted mb-2">
                        Per Night
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="option-footer">
                    {/* <span className="coupon-text">
                      EMTSTAY Coupon Applied
                    </span> */}
                    <div className="user-button">
                      <MuiButton
                        className="get-btn w-auto px-5 rounded-pill"
                        label="Book Now"
                        type="submit"
                        onClick={() => onBookRoom?.(room)}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
};

export default RoomList;
